import React, { useState } from "react";

import Drawer from "@material-ui/core/Drawer";
import DocumentDoctor from "../../DocumentDoctor";
import PrescriptionComponent from "../../DoctorVideo/PrescriptionComponent";
import DocumentContainer from "../../UI Component/DocumentViewer/DocumentCotainer";
import CloseIcon from "../../../assets/close_icon.png";
import PrescriptionTabComponent from "../../PrescriptionTabComponent";

export default function ClinicDrawerComponent(props) {
  const [documentShow, setDocumentShow] = useState(false);

  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");

  const [fullView, setFullView] = useState(false);

  const [drowerPostionInitianlView, setDrowerPostionInitianlView] =
    useState(false);

  function renderDocument(width) {
    if (documentShow) {
      return (
        <DocumentContainer
          cancelHandler={closeNotification}
          fullViewHandler={() => {
            setFullView(!fullView);
          }}
          url={fileUrl}
          fileName={fileName}
          fileType={fileType}
          width={width || ""}
        />
      );
    }
  }

  function viewDocument({ fileURL, fileName, fileType }) {
    if (fileType && fileType.match(/pdf/gim)) {
      downloadURI(fileURL, fileName);
    } else {
      setDocumentShow(true);
      setFileUrl(fileURL);
      setFileName(fileName);
      setFileType(fileType);
    }
  }

  function closeNotification() {
    setDocumentShow(false);
    setFileUrl("");
    setFileName("");
    setFileType("");
    setFullView(false);
  }

  function downloadURI(uri, name) {
    let link = document.createElement("a");
    link.href = uri;
    link.target = "_blank";
    link.click();
  }

  return (
    <Drawer
      anchor={"right"}
      open={props.drawerOpen}
      onClose={props.toggleDrawer}
      className={`${drowerPostionInitianlView ? "drawer_component" : ""}`}
    >
      <div
        className={`py-3  px-2 px-md-2 ${
          props.drawerType !== "Documents"
            ? "prescription-drawer"
            : "previous-patients-prescription-edit-drawer"
        }`}
      >
        <div className="container pl-0 pr-2">
          <h2>
            {props.drawerType !== "Documents"
              ? "Prescription"
              : props.drawerType}
            <span
              className="float-right cursor-pointer mt-2"
              onClick={props.toggleDrawer}
              style={{ fontSize: "1rem" }}
            >
              <img src={CloseIcon} alt="Close" />
              {/* Close <i className="fa fa-times" aria-hidden="true"></i> */}
            </span>
          </h2>
        </div>

        {props.drawerType === "View Documents" ||
        props.drawerType === "Documents" ? (
          <DocumentDoctor
            appointmentData={props?.appointmentForDrawer}
            documentShow={documentShow}
            actions={{
              viewDocumentAction: viewDocument,
            }}
          >
            {renderDocument("98%")}
          </DocumentDoctor>
        ) : props?.drawerType === "Edit Prescription" ||
          props?.drawerType === "Create Prescription" ||
          props?.drawerType === "Upload Prescription" ||
          props?.drawerType === "Manage Prescription" ? (
          <PrescriptionTabComponent
            appointmentData={props?.appointmentForDrawer}
            age={props?.ageForDrawer}
            fetchPastAppointmentDataList={props?.fetchPastAppointmentDataList}
            closeDrawer={() => {
              this.closeDrawerAction();
            }}
            drawerType={props?.drawerType}
            setDrowerPostionInitianlView={setDrowerPostionInitianlView}
          />
        ) : (
          // <PrescriptionComponent
          //   appointmentData={props?.appointmentForDrawer}
          //   age={props?.ageForDrawer}
          //   fetchPastAppointmentDataList={props?.fetchPastAppointmentDataList}
          //   closeDrawer={() => {
          //     this.closeDrawerAction();
          //   }}
          //   drawerType={props?.drawerType}
          //   setDrowerPostionInitianlView={setDrowerPostionInitianlView}
          // />
          ""
        )}
      </div>
    </Drawer>
  );
}
